import React, { useState, useEffect, useLayoutEffect } from 'react'
import { utils as EthersUtils } from 'ethers'
import { RouteComponentProps } from 'react-router-dom'
import styled from 'styled-components'

const MainContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: #1a1a1a;
`

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
`

const Toast = styled.div<{ type: 'success' | 'error' | 'info' }>`
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 50;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  color: #fff;
  background: ${p => (p.type === 'success' ? '#10b981' : p.type === 'error' ? '#ef4444' : '#374151')};
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
`

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-left: 256px;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`

const HeaderWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`

const HeaderInner = styled.div`
  position: relative;
`

const Logo = styled.img`
  width: 361px;
  height: 132px;
  object-fit: contain;
  @media (max-width: 768px) {
    width: 240px;
    height: auto;
  }
`

const Badge = styled.div`
  position: absolute;
  right: -124px;
  top: 16px;
  background: #c1ff72;
  color: #000;
  padding: 4px 16px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
  @media (max-width: 768px) {
    right: -40px;
    top: -12px;
    font-size: 14px;
  }
`

const Card = styled.div`
  width: 100%;
  max-width: 960px;
  margin: 0 auto 32px;
  background: linear-gradient(180deg, #000 0%, #231f20 100%);
  border-radius: 12px;
  padding: 16px 24px;
  box-shadow: 0 10px 9.4px -2px rgba(0, 0, 0, 0.25);
`

const CardTitle = styled.h2`
  color: #d9d9d9;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 12px;
`

const InputRow = styled.div`
  display: flex;
  align-items: center;
  background: #212121;
  border-radius: 5px;
  overflow: hidden;
  height: 36px;
  margin-bottom: 12px;
`

const IconBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 100%;
  background: #212121;
`

const AddressInput = styled.input`
  flex: 1;
  background: #212121;
  color: #fff;
  padding: 0 8px;
  font-size: 14px;
  border: none;
  outline: none;
  ::placeholder {
    color: #9ca3af;
  }
`

const PrimaryButton = styled.button<{ disabled?: boolean }>`
  width: 100%;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  background: #c1ff72;
  color: #000;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 10px;
  transition: background 0.2s ease;
  font-size: 14px;
  margin-bottom: 12px;
  opacity: ${p => (p.disabled ? 0.5 : 1)};
  &:hover {
    background: ${p => (p.disabled ? '#c1ff72' : '#b8f066')};
  }
`

const Note = styled.p`
  color: #d9d9d9;
  font-size: 12px;
  text-align: center;
  margin: 0 0 20px;
`

const FAQWrap = styled.div`
  max-width: 960px;
  margin: 0 auto;
`

const FAQTitle = styled.h2`
  color: #fff;
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  margin: 0 0 24px;
`

const FAQItemTitle = styled.h3`
  color: #c1ff72;
  font-weight: 600;
  font-size: 18px;
  margin: 0 0 8px;
`

const FAQText = styled.p`
  color: #fff;
  line-height: 1.6;
  font-size: 14px;
  margin: 0 0 16px;
`

// 新增AWS WAF CAPTCHA相关样式
const CaptchaContainer = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 78px;
  background: #212121;
  border-radius: 8px;
  padding: 12px;

  /* 为CAPTCHA元素添加样式 */
  #captcha-element {
    color: #000 !important;
    background-color: #fff !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    font-family: Arial, sans-serif !important;
    padding: 10px !important;
    width: auto !important;
    height: 100% !important;
  }

  /* 为CAPTCHA内的所有元素添加样式 */
  #captcha-element * {
    color: #000 !important;
    background-color: #fff !important;
  }

  /* 为CAPTCHA按钮添加样式 */
  #captcha-element button {
    background-color: #c1ff72 !important;
    color: #000000 !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
  }

  /* 为CAPTCHA输入框添加样式 */
  #captcha-element input {
    background-color: #212121 !important;
    color: #ffffff !important;
    border: 1px solid #374151 !important;
    border-radius: 4px !important;
    padding: 8px !important;
    font-size: 14px !important;
  }

  #captcha-element #amzn-btn-verify-internal {
    background-color: #c1ff72 !important;
    color: #000000 !important;
    border: none !important;
    border-radius: 4px !important;
    padding: 8px 16px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
  }
`

const CaptchaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
`

const CaptchaStatus = styled.div<{ verified: boolean }>`
  color: ${props => (props.verified ? '#10b981' : '#ef4444')};
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
`

const LoadingSpinner = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid #374151;
  border-top: 2px solid #c1ff72;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

const RetryButton = styled.button`
  background: #c1ff72;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #b8f066;
  }
`

// 声明AWS WAF CAPTCHA类型
declare global {
  interface Window {
    AwsWafCaptcha: any
    AwsWafIntegration: any
  }
}

export default function Faucet({ history }: RouteComponentProps) {
  const [walletAddress, setWalletAddress] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState<{ type: 'success' | 'error' | 'info' | null; text: string }>({
    type: null,
    text: ''
  })

  // AWS WAF CAPTCHA相关状态
  const [captchaVerified, setCaptchaVerified] = useState(false)
  const [captchaLoading, setCaptchaLoading] = useState(false)
  const [captchaError, setCaptchaError] = useState<string>('')
  const [showCaptcha, setShowCaptcha] = useState(false)
  const [captchaEl, setCaptchaEl] = useState<HTMLDivElement | null>(null)

  // AWS WAF CAPTCHA配置
  const AWS_WAF_CAPTCHA_API_KEY =
    'wsTUqFz4RheFNZuNL3orqHC8sI7uHCpbMBZEPBQu147veHpVcmbTNT2l+fFcOq2lygzWT5J8G5eP0PZoAIHYANgQL5j//DRa7Ba9kMQFRjGOlCVVrkZVa877+tljdvPLGIbFH3T96nZO7ynIsosnPQsOvTYHGGBkdtxCg6T1Ln60CywUmn30Vo+CbEKx5sk94L5/4kJH3vHqt+2wSMYy/MDj5evVBfFBzc5orWsLjuZUBPLrG6rwFl3sYkc7VTbfQ0R5q8zx4ONEPNkdFYdZvsqQIho5lPyZCcY3kkg8N8i/zABThcpqgzCSivCPbAzniM+Ne1p6hIiw2XL9mf/WvHXUz/1c2CS8+qaScf8V45irPQLeGVZQZ9Qv2dHVhniUWE3lriTvt8z676XLa0qb+SCF5LkEzAxq8Rx/1Q1yCNlr3v/T85bXklYUqIk9S3IIoKwjlUksDX5XjLLMcU3IbCBeS4kGWfbxwUR4c/PshifmgayLG5/sWPeI5AhVNmcHZhjUU0Oe05+DMgV3zZWJvSb3/djSQ7oxd6v0uDn8/s0ZvGSZ4WhNaPwLNriSiZCrm04foSaCwUGtjUeVLG6K63Un68kUKtDeIsWJiQavv5SVWgnDstdcJuMBMA4CT/U6nk+sd+eQd9R0l/bIhKUC/Nf9cjNtssxtnBHTiTa7YDE=_0_1'

  const showMessage = (type: 'success' | 'error' | 'info', text: string) => {
    setMessage({ type, text })
  }

  const clearMessageLater = () => {
    setTimeout(() => setMessage({ type: null, text: '' }), 4000)
  }

  // 调用转账API
  const callTransferAPI = async (wafToken: string) => {
    const trimmedAddress = walletAddress.trim()
    let normalizedAddress = trimmedAddress

    try {
      if (!EthersUtils.isAddress(trimmedAddress)) {
        showMessage('error', 'Please enter a valid wallet address')
        clearMessageLater()
        return
      }

      normalizedAddress = EthersUtils.getAddress(trimmedAddress)
    } catch (error) {
      showMessage('error', error instanceof Error ? error.message : 'Please enter a valid wallet address')
      clearMessageLater()
      return
    }

    setIsLoading(true)
    showMessage('info', 'Claiming MOVA gas...')

    try {
      if (window.AwsWafIntegration) {
        const response = await window.AwsWafIntegration.fetch(
          'https://faucet.api.movachain.com/api/faucet/v1/transfer',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-amzn-waf-captcha-token': wafToken
            },
            body: JSON.stringify({ to: normalizedAddress })
          }
        )

        if (response.ok) {
          const data = await response.json()
          if (data.error && data.error !== '200') {
            // showMessage('error', `Transfer failed: ${data.err_msg || data.data || 'Server error'}`)
            if (data.err_msg && data.err_msg == 'claim limit exceeded') {
              showMessage('error', `Claim failed. Claim limit exceeded.`)
            } else if (data.err_msg && data.err_msg == 'invalid request parameters') {
              showMessage('error', `Claim failed. Invalid request parameters.`)
            } else {
              showMessage('error', `Claim failed. Please check your wallet address and try again later.`)
            }
          } else {
            showMessage('success', 'Claim successful. MOVA gas has been sent to your wallet.')
          }
        } else {
          // const errorData = await response.json().catch(() => ({} as any))
          showMessage('error', `Claim failed. Please check your wallet address and try again later.`)
        }
      } else {
        // 若无 SDK，则无法保证通过WAF挑战；建议仅在受保护域启用或引入SDK
        showMessage('error', 'AWS WAF Integration not loaded. Please ensure it is included in your HTML.')
      }
    } catch (error) {
      console.error('Network error:', error)
      showMessage('error', 'Claim failed. Please check your wallet address and try again later.')
    } finally {
      setIsLoading(false)
      clearMessageLater()
    }
  }

  // 重置CAPTCHA
  const resetCaptcha = () => {
    setCaptchaVerified(false)
    setCaptchaError('')
    setCaptchaLoading(false)
    setShowCaptcha(false)
    if (captchaEl) {
      captchaEl.innerHTML = ''
    }
  }

  // CAPTCHA回调函数
  const captchaExampleSuccessFunction = async (wafToken: string) => {
    console.log('captchaExampleSuccessFunction wafToken:', wafToken)
    setCaptchaLoading(false)
    try {
      await callTransferAPI(wafToken)
    } finally {
      resetCaptcha() // 调用后重置，下一次点击必须再次验证
    }
  }

  const captchaExampleErrorFunction = (error: any) => {
    console.log('captchaExampleErrorFunction:', error)
    setCaptchaLoading(false)
    setCaptchaError('CAPTCHA verification error: ' + (error?.message || 'Unknown error'))
    // 不 resetCaptcha()，保留组件让用户重试
  }

  // 监听 showCaptcha 渲染 CAPTCHA
  useLayoutEffect(() => {
    if (!showCaptcha) return
    // let attempts = 0
    // const max = 50

    const tryRender = () => {
      const client = (window as any).AwsWafCaptcha
      if (client && typeof client.renderCaptcha === 'function' && captchaEl) {
        captchaEl.innerHTML = ''
        client.renderCaptcha(captchaEl, {
          apiKey: AWS_WAF_CAPTCHA_API_KEY,
          defaultLocale: 'en',
          onSuccess: captchaExampleSuccessFunction,
          onError: captchaExampleErrorFunction
        })
        setCaptchaLoading(false)
        return
      }
      // if (attempts++ < max) {
      //   setTimeout(tryRender, 100)
      // } else {
      //   setCaptchaError('CAPTCHA SDK not ready')
      //   setCaptchaLoading(false)
      // }
    }

    // 等一帧保证节点挂载
    requestAnimationFrame(tryRender)
  }, [showCaptcha, captchaEl])

  // 简化showMyCaptcha函数
  // const showMyCaptcha = () => {
  //   if (!window.AwsWafCaptcha) {
  //     console.log('AWS WAF CAPTCHA not loaded')
  //     setCaptchaError('AWS WAF CAPTCHA not loaded')
  //     return
  //   }

  //   setShowCaptcha(true)
  //   setCaptchaError('')
  // }

  // 检查AWS WAF CAPTCHA是否加载
  useEffect(() => {
    const checkForCaptcha = () => {
      if (window.AwsWafCaptcha) {
        console.log('AWS WAF CAPTCHA loaded successfully')
      } else {
        console.log('AWS WAF CAPTCHA not loaded, retrying...')
        setTimeout(checkForCaptcha, 500)
      }
    }

    // 延迟检查，确保脚本有时间加载
    setTimeout(checkForCaptcha, 1000)
  }, [])

  // 处理获取代币按钮点击
  const handleGetTokens = async () => {
    const trimmedAddress = walletAddress.trim()
    if (!trimmedAddress) {
      showMessage('error', 'Please enter a wallet address')
      clearMessageLater()
      return
    }
    // 每次点击都强制重新走 CAPTCHA
    setCaptchaVerified(false)
    setCaptchaError('')
    setCaptchaLoading(true)
    setShowCaptcha(true)
  }

  return (
    <MainContainer>
      <ContentContainer>
        <PageContainer>
          {message.type && <Toast type={message.type}>{message.text}</Toast>}

          <HeaderWrap>
            <HeaderInner>
              <Logo src="/mova-logo-banner.svg" alt="MOVA" />
              <Badge>Mainnet Faucet</Badge>
            </HeaderInner>
          </HeaderWrap>

          <Card>
            <CardTitle>Enter wallet address</CardTitle>

            <InputRow>
              <IconBox>
                <img src="/wallet_icon.svg" alt="Wallet" width={24} height={24} />
              </IconBox>
              <AddressInput
                type="text"
                value={walletAddress}
                onChange={e => setWalletAddress(e.target.value)}
                placeholder="0x8ce78...28161"
                disabled={isLoading}
              />
            </InputRow>

            {/* always mounted, just hide when not needed */}
            <CaptchaContainer style={{ display: showCaptcha ? 'block' : 'none' }}>
              <CaptchaWrapper>
                {captchaLoading ? (
                  <>
                    <LoadingSpinner />
                    <CaptchaStatus verified={false}>Loading CAPTCHA...</CaptchaStatus>
                  </>
                ) : captchaVerified ? (
                  <>
                    <CaptchaStatus verified={true}>✓ Human verification passed</CaptchaStatus>
                    <RetryButton onClick={resetCaptcha}>Re-verify</RetryButton>
                  </>
                ) : (
                  <>
                    <div id="captcha-element" ref={setCaptchaEl} />
                    {captchaError && <CaptchaStatus verified={false}>{captchaError}</CaptchaStatus>}
                    {/* <RetryButton onClick={resetCaptcha}>Reset CAPTCHA</RetryButton> */}
                  </>
                )}
              </CaptchaWrapper>
            </CaptchaContainer>

            <PrimaryButton onClick={handleGetTokens} disabled={isLoading || true}>
              {/* {isLoading ? 'Sending...' : captchaVerified ? 'Claim MOVA Gas' : 'Claim MOVA Gas'} */}
              Faucet is closed!
            </PrimaryButton>

            <Note>
              MOVA gas is used for transaction fees on the MOVA Mainnet. Claims are subject to eligibility, daily
              limits, and faucet availability.
            </Note>
          </Card>

          <FAQWrap>
            <FAQTitle>Frequently Asked Questions</FAQTitle>

            <div>
              <FAQItemTitle>What is the MOVA Mainnet Faucet?</FAQItemTitle>
              <FAQText>
                The MOVA Mainnet Faucet allows eligible users to claim a small amount of MOVA gas for activating wallets
                and interacting with the MOVA Mainnet. It is designed to help new users complete basic on-chain
                operations more easily.
              </FAQText>
            </div>

            <div>
              <FAQItemTitle>How can I claim MOVA gas?</FAQItemTitle>
              <FAQText>
                Each wallet address can claim 0.001 MOVA only once. To ensure fair distribution, each IP address is also
                limited to one claim. Claims are subject to eligibility verification, faucet balance, and official MOVA
                ecosystem rules.
              </FAQText>
            </div>
          </FAQWrap>
        </PageContainer>
      </ContentContainer>
    </MainContainer>
  )
}
